import User from "../view/listings/User";
import Login from "../view/Login";
import CraftDesignManager from "../view/listings/CraftDesignManager";

const routes = [
  {
    path: "/",
    component: Login,
  },
  {
    path: "/craftdesign",
    component: CraftDesignManager,
  },
  

  {
    path: "/users",
    component: User,
  },
  
];
export default routes;
